import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../api/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Attach token to axios globally
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    } else {
      delete api.defaults.headers.common["Authorization"];
    }
  }, []);
  

  useEffect(() => {
    const verifyUser = async () => {
      const storedUser = localStorage.getItem("user");
      const storedToken = localStorage.getItem("token");

      if (!storedUser || !storedToken) {
        setLoading(false);
        return;
      }

      // Restore user immediately (avoid logout on refresh)
      setUser(JSON.parse(storedUser));

      try {
        const res = await api.get("/auth/verify", {
          headers: { Authorization: `Bearer ${storedToken}` },
        });

        if (!res.data.valid) {
          logout(); // Token confirmed invalid by backend
        }
      } catch (err) {
        console.warn("Token verify failed, but not logging out automatically.");
        // Do NOT logout here — allow user to stay logged in
      }

      setLoading(false);
    };

    verifyUser();
  }, []);

  const login = (userData, token, company) => {
    const fullUser = { ...userData, companyName: company?.name || "" };
    setUser(fullUser);
    localStorage.setItem("user", JSON.stringify(fullUser));
    localStorage.setItem("token", token);

    // attach token globally
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  };

  const logout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    sessionStorage.clear();
    setUser(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
